import axiosRequest from "../axios-request";


const apiObtenerCredenciales = async (datos) => {
    const result = await axiosRequest(
        "get",
        "/sucursalVirtual/crm/detalleContrato/obtenerCredencialesRed",
        datos,
        null,
        false
    );

    if (result && result.status == 200) {
        return result.data;
    }

};

const apiApagarRed = async (datos) => {
    const result = await axiosRequest(
        "get",
        "/sucursalVirtual/crm/provision/disableRed5",
        datos,
        null,
        false
    );

    if (result && result.status == 200) {
        return result.data;
    }

};

const apiListarDispositivos = async (datos) => {
    const result = await axiosRequest(
        "get",
        "/sucursalVirtual/crm/provision/dispositivosConectados",
        datos,
        null,
        false
    );

    if (result && result.status == 200) {
        return result.data;
    }

};



export {
    apiObtenerCredenciales,
    apiApagarRed,
    apiListarDispositivos
}